export default function Comparator(a:any, b:any, direction:any, string:any) {
  if(!a || !b) return -1;
  if (string) {
    return a.localeCompare(b) * direction;
  }
  return (a - b) * direction;
}
